/*
 * サブシステム名：請求
 * 機能名：請求明細一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdSwitch from '@/components/DdSwitch'
import DdTextBox from '@/components/DdTextBox.vue'
import DdCheckbox from '@/components/DdCheckbox.vue'
import DdNumericBox from '@/components/DdNumericBox'
import flowMixin from '@/mixins/flowMixins'

import modals from '@/ddv2.library/modals'
import filter from '@/rahmen/utils/filters'
import message from '@/ddv2.library/messages'

import D2bild0030 from '@/views/BIL/D2BILD0030.vue'

export default {
  name: 'SeikyuMeisaiList',
  mixins: [flowMixin],
  data: () => ({
    rows: [],
    params: {},
    seikyuKihon: {},
    seikyusaki: {},
    isExistsKeshikomi: false,
    expansionPanel: [0, 1],
    seikyusakiCdNmText: '',
    tokuisakiCdNmText: '',
    eigyoshoCdNmText: '',
    shimeDateText: '',
    seikyushoText: '',
    unchinGoukeiSum: 0,
    unchinSum: 0,
    warimashiSum: 0,
    sonotaKazeiSum: 0,
    taxSum: 0,
    hiwaySum: 0,
    sonotaUchizeiSum: 0,
    sonotaHikazeiSum: 0,
    conditions: {
      seikyuYmd: '',
      seikyuYm: '',
      shimeDay: '',
      shiborikomiStartYmd: '',
      shiborikomiEndYmd: '',
      seikyusakiId: '',
      eigyoshoId: '',
      seikyushoKarihakkoFlg: false,
      kingakuZeroFlg: false,
      kingakuKakutei: '01',
      shimebiIgaiHyojiFlg: false,
      seikyuDomeHyojiFlg: false
    },
    page: 1,
    modeKengen: 0,
    // 表示制御
    dispSeikyusho: '',
    dispSeikyuMeisaiIchiranCsv: '',
    hideFlg: false,
    // フィルター定義
    rowFilterConditions: {
      seikyuKingaku: 0
    },
    // ダイアログ
    showSeikyuBikoEditDialog: false,
    seikyuKihonClone: {},
    lastShimeYmd: ''
  }),
  components: {
    DdSubHeader,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdDateBox,
    DdCheckbox,
    DdSwitch,
    DdTextBox,
    DdNumericBox,
    // ダイアログ
    D2bild0030
  },
  computed: {
    filteredRows () {
      const self = this
      return self.rows.filter(function (elem) {
        return self.hideFilter(elem)
      }).map((elem, index) => {
        // 数値項目編集
        elem.dispNo = index + 1
        elem.unchinGokeiZeikomiDisp = (elem.unchinGokeiZeikomi ? filter.numericFormatter(elem.unchinGokeiZeikomi) : 0) + '円'
        elem.kihonUnchinDisp = (elem.kihonUnchin ? filter.numericFormatter(elem.kihonUnchin) : 0) + '円'
        elem.jikanWarimashiKingakuDisp = (elem.jikanWarimashiKingaku ? filter.numericFormatter(elem.jikanWarimashiKingaku) : 0) + '円'
        elem.kyoriWarimashiKingakuDisp = (elem.kyoriWarimashiKingaku ? filter.numericFormatter(elem.kyoriWarimashiKingaku) : 0) + '円'
        elem.keisuWarimashiKingakuDisp = (elem.keisuWarimashiKingaku ? filter.numericFormatter(elem.keisuWarimashiKingaku) : 0) + '円'
        elem.nenryoWarimashiKingakuDisp = (elem.nenryoWarimashiKingaku ? filter.numericFormatter(elem.nenryoWarimashiKingaku) : 0) + '円'
        elem.userKazeiKingakuGokeiDisp = (elem.userKazeiKingakuGokei ? filter.numericFormatter(elem.userKazeiKingakuGokei) : 0) + '円'
        elem.taxDisp = (elem.tax ? filter.numericFormatter(elem.tax) : 0) + '円'
        elem.hiwayPriceDisp = (elem.hiwayPrice ? filter.numericFormatter(elem.hiwayPrice) : 0) + '円'
        elem.userUchizeiKingakuGokeiDisp = (elem.userUchizeiKingakuGokei ? filter.numericFormatter(elem.userUchizeiKingakuGokei) : 0) + '円'
        elem.userHikazeiKingakuGokeiDisp = (elem.userHikazeiKingakuGokei ? filter.numericFormatter(elem.userHikazeiKingakuGokei) : 0) + '円'
        elem.seikyuJuryoDisp = (elem.seikyuJuryo ? filter.numericFormatter(elem.seikyuJuryo) : 0)
        elem.seikyuSuryoDisp = (elem.seikyuSuryo ? filter.numericFormatter(elem.seikyuSuryo) : 0)
        elem.tankaDisp = (elem.tanka ? filter.numericFormatter(elem.tanka) : 0) + '円'
        // 日付項目編集
        elem.sagyoYoteiYmdDisp = elem.sagyoYoteiYmd ? filter.dateFormatter(elem.sagyoYoteiYmd) : ''
        elem.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        return elem
      })
    },
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isSeikyu () {
      return this.params.seikyusho !== '未出力'
    },
    isSeikyuTorikeshi () {
      return this.params.seikyusho === '取消済'
    },
    isKarihakko () {
      return this.params.kariHakkoFlg
    },
    isNotExistSeikyushoLayoutKbn () {
      return !this.seikyusaki.seikyushoLayoutKbn && !this.seikyusaki.seikyuMeisaishoLayoutKbn
    },
    isNoParam () {
      return Object.keys(this.params).length === 0
    },
    isShoukaiMode () {
      return this.modeKengen === 0
    },
    isBikoButtonDisp () {
      return this.isSeikyu && !this.isNoParam
    },
    isPrintAgainButtonDisp () {
      return this.isSeikyu && !this.isSeikyuTorikeshi && !this.isNoParam
    },
    isCancelButtonDisp () {
      return this.isSeikyu && !this.isSeikyuTorikeshi && !this.isKarihakko && this.modeKengen === 2 && !this.isNoParam
    },
    isPrintButtonDisp () {
      return !this.isSeikyu && !this.isShoukaiMode && !this.isNoParam
    },
    apiPathSearch () {
      var path = ''
      if (this.conditions.seikyusho === '未出力') {
        // 未請求（受注情報）の場合
        path = '/api/v1/d2bild0020/searchSeikyuMeisaiWork'
      } else {
        path = '/api/v1/d2bild0020/searchSeikyuMeisai'
      }
      return path
    }
  },
  created () {
    this.params = this.$route.params
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {}
    },
    initialize: function () {
      const self = this
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'dispNo' },
              { text: '受注番号', value: 'juchuNo' },
              { text: '受注先区分', value: 'juchusakiKbnNm' },
              { text: '運賃確定状況', value: 'unchinKakuteiFlgNm' },
              { text: '作業予定日', value: 'sagyoYoteiYmdDisp' },
              { text: '運賃合計', value: 'unchinGokeiZeikomiDisp', align: 'end' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '(基本運賃)', value: 'kihonUnchinDisp', align: 'end' },
              { text: '(時間割増)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
              { text: '(距離割増)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
              { text: '(係数割増)', value: 'keisuWarimashiKingakuDisp', align: 'end' },
              { text: '(燃料割増)', value: 'nenryoWarimashiKingakuDisp', align: 'end' },
              { text: '(その他課税)', value: 'userKazeiKingakuGokeiDisp', align: 'end' },
              { text: '(消費税)', value: 'taxDisp', align: 'end' },
              { text: '(高速代)', value: 'hiwayPriceDisp', align: 'end' },
              { text: '(その他内税)', value: 'userUchizeiKingakuGokeiDisp', align: 'end' },
              { text: '(その他非課税)', value: 'userHikazeiKingakuGokeiDisp', align: 'end' },
              { text: '品名コード/名称', value: 'hinmeiCdNm' },
              { text: '重量', value: 'seikyuJuryoDisp', align: 'end' },
              { text: '数量', value: 'seikyuSuryoDisp', align: 'end' },
              { text: '単位', value: 'unitKbnNm' },
              { text: '得意先コード/名称', value: 'torihikisakiCdNm' },
              { text: '運賃計算', value: 'unchinKeisanKbnNm' },
              { text: '単価', value: 'tankaDisp', align: 'end' },
              { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
              { text: '発地日時', value: 'hatsuchiYmdHms' },
              { text: '着地日時', value: 'chakuchiYmdHms' },
              { text: '備考', value: 'seikyuBiko' }
              // { text: '明細番号', value: 'juchuMeisaiNo' },
              // { text: '品目番号', value: 'juchuHinmokuNo' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            if (self.isNoParam) {
              // 請求一覧画面からパラメータが渡されていない（当画面をリロードした）場合
              // 請求一覧画面から受け取ったパラメータをキャッシュから再現するようにしている
              self.loadFromCache()
                .then((c) => {
                  self.params = c.value.params || {}
                  resolve()
                })
            } else {
              resolve()
            }
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          self.conditions = { ...self.conditions, ...c }
          var shimebiIgaiHyojiFlgBool = c.shimebiIgaiHyojiFlg === 'true'
          self.conditions.shimebiIgaiHyojiFlg = shimebiIgaiHyojiFlgBool
          var seikyuDomeHyojiFlgBool = c.seikyuDomeHyojiFlg === 'true'
          self.conditions.seikyuDomeHyojiFlg = seikyuDomeHyojiFlgBool
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                // 画面起動時に検索するため、ユーザ保存項目を復元してから検索する
                self.initSearch()
                  .then(() => {
                    resolve()
                  })
                // resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            self.params = c.cache.value ? c.cache.value.params || {} : self.params
            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
      this.getShimeJisseki()
    },
    initSearch: function () {
      const self = this
      return new Promise(resolve => {
        if (self.isNoParam) { return resolve() }
        self.seikyusakiCdNmText = self.params.seikyusakiCd ? self.params.seikyusakiCd + ':' + self.params.seikyusakiNm : ' '
        self.tokuisakiCdNmText = self.params.seikyusakiCd ? self.params.seikyusakiCd + ':' + self.params.seikyusakiNm : ' '
        self.eigyoshoCdNmText = self.params.eigyoshoCd ? self.params.eigyoshoCd + ':' + self.params.eigyoshoNm : ' '
        // 末日99
        var shimeDateText
        if (self.params.shimeDay) {
          const day = self.params.shimeDay.trim()
          if (day === '99') {
            shimeDateText = '末日締め '
          } else {
            shimeDateText = day + '日締め '
          }
          self.shimeDateText = shimeDateText + filter.dateFormatter(self.params.shiborikomiStartYmd) + ' ～ ' + filter.dateFormatter(self.params.shiborikomiEndYmd)
        } else {
          self.shimeDateText = 'なし '
        }
        self.seikyushoText = self.params.seikyusho + ' / ' + self.params.seikyuNo

        self.conditions.id = self.params.seikyuId
        self.conditions.seikyuYmd = filter.dateFormatter(self.params.seikyuYmd)
        self.conditions.seikyuYm = self.params.shimeYm ? self.params.shimeYm.trim() : ''
        self.conditions.shimeDay = self.params.shimeDay ? self.params.shimeDay.trim() : ''
        self.conditions.shiborikomiStartYmdString = filter.dateFormatter(self.params.shiborikomiStartYmd)
        self.conditions.shiborikomiEndYmdString = filter.dateFormatter(self.params.shiborikomiEndYmd)
        self.conditions.torihikisakiCd = self.params.seikyusakiCd ? self.params.seikyusakiCd : ''
        self.conditions.eigyoshoCd = self.params.eigyoshoCd ? self.params.eigyoshoCd : ''
        self.conditions.seikyushoKarihakkoFlg = self.params.kariHakkoFlg
        self.conditions.kingakuZeroFlg = self.params.seikyuZeroFlg
        self.conditions.seikyusho = self.params.seikyusho
        self.conditions.seikyuNo = self.params.seikyuNo ? self.params.seikyuNo.trim() : ''

        self.HttpClient.post(self.apiPathSearch, self.conditions)
          .then((data) => {
            self.searchResultMethodCustom(data)
            resolve()
          })
      })
    },
    searchResultMethodCustom: function (data) {
      const self = this
      self.rows = []
      if (!self.isSeikyuTorikeshi) {
        // 取消済以外の場合（取消は明細表示しない）
        self.rows = data.payload.vwCD2bild0020List || []
      }
      var initSeikyuKihon = {
        konkaiSeikyuKingaku: 0,
        kihonUnchiGokei: 0,
        warimashiKingakuGokei: 0,
        kazeiKingakuGokei: 0,
        konkaiTax: 0,
        hiwayPriceGokei: 0,
        uchizeiKingakuGokei: 0,
        hikazeiKingakuGokei: 0
      }
      var initMstSeikyusaki = {
        seikyushoLayoutKbn: false,
        seikyuMeisaishoLayoutKbn: false
      }

      // 請求基本情報
      if (!self.isSeikyu) {
        // 未請求（受注情報）の場合
        self.seikyuKihon = data.payload.wkSeikyuKihon || initSeikyuKihon
      } else {
        // 請求済（請求情報）の場合
        self.seikyuKihon = data.payload.trSeikyuKihon || initSeikyuKihon
      }
      // 請求先マスタ情報
      self.seikyusaki = data.payload.mstSeikyusaki || initMstSeikyusaki
      // 請求消込存在確認
      self.isExistsKeshikomi = data.payload.isExistsKeshikomi || false

      const cache = {
        rows: self.rows,
        conditions: self.conditions,
        searchText: self.searchText,
        params: self.params
      }
      self.saveToChache(cache)
        .then(() => {
        })
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(self.apiPathSearch, self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.searchResultMethodCustom(data)
        },
        getSavedInputMethod: function () {
          if (!self.isSeikyu) {
            // 未請求時のみの項目
            return {
              kingakuKakutei: self.conditions.kingakuKakutei,
              shimebiIgaiHyojiFlg: self.conditions.shimebiIgaiHyojiFlg,
              seikyuDomeHyojiFlg: self.conditions.seikyuDomeHyojiFlg
            }
          } else {
            return {}
          }
        }
      }
      this.search(opt)
    },
    onRowClick: function (row) {
      if (row.trJuchuHinmokuId) {
        if (!this.isSeikyu) {
          console.log('受注品目（未出力）id', row.trJuchuHinmokuId)
        } else {
          console.log('受注品目（出力済）id', row.trJuchuHinmokuId)
        }
      } else if (row.trJuchuMeisaiId) {
        if (!this.isSeikyu) {
          console.log('受注明細（未出力）id', row.trJuchuMeisaiId)
        } else {
          console.log('受注明細（出力済）id', row.trJuchuMeisaiId)
        }
      } else {
        if (!this.isSeikyu) {
          console.log('受注基本（未出力）id', row.trJuchuKihonId)
        } else {
          console.log('受注基本（出力済）id', row.trJuchuKihonId)
        }
      }
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: self.params
          }
        }
      }

      this.transitionBack(opt)
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.dispSeikyuMeisaiIchiranCsv = `請求明細一覧_${this.getTimeStamp()}.csv`
      this.HttpClient
        .post('/api/v1/d2bild0020/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0005')
          this.Effects.loadComplete()
        })
    },
    // 請求備考入力ダイアログ
    onBikoButtonClick: function () {
      if (this.lastShimeYmd !== '') {
        if (this.seikyuKihon.seikyuYmd <= this.lastShimeYmd) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      // ダイアログ起動時の請求基本情報を保持
      this.seikyuKihonClone = JSON.parse(JSON.stringify(this.seikyuKihon))
      this.showSeikyuBikoEditDialog = true
    },
    dialogClosed: function (data) {
      this.showSeikyuBikoEditDialog = false
      if (data === undefined) {
        // ダイアログで閉じるボタン押下
        // ダイアログ起動時の請求基本情報に復元
        this.seikyuKihon = JSON.parse(JSON.stringify(this.seikyuKihonClone))
      } else {
        // ダイアログで登録ボタン押下
        this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
        if (data.isValid === true) {
          // 正常
          // 請求基本情報を最新化（更新日時を更新しないと連続登録が不可）
          this.seikyuKihon = data.payload
        } else {
          // 異常
        }
      }
    },
    onCancelButtonClick: function () {
      // 請求消込を行ったデータだった場合、エラー
      if (this.isExistsKeshikomi) {
        this.setInvalidSummaryMessage('BILE0006')
        return false
      }
      // 月次確定処理を行ったデータだった場合、エラー
      if (this.seikyuKihon.trKessanGetsujiKanriId) {
        this.setInvalidSummaryMessage('BZME0001')
        return false
      }
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        var list = []
        var row = JSON.parse(JSON.stringify(this.conditions))
        // 消込存在確認項目の設定
        row.trSeikyuKeshikomiMeisaiId = this.isExistsKeshikomi ? 0 : null
        list.push(row)
        this.HttpClient.post('/api/v1/d2bild0010/seikyucancel', list)
          .then((data) => {
            if (data.payload) {
              // 取消処理が正常に終了した場合
              this.params.seikyusho = '取消済'
            }
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            if (data.summaryMessage != null) {
              this.setInvalidSummaryMessage(data.summaryMessage.messageCd)
            } else {
              this.setInvalidSummaryMessage('COMI0005')
            }
          })
      })
    },
    onPrintButtonClick: function (seikyushoKarihakkoFlg) {
      if (this.lastShimeYmd !== '') {
        if (this.conditions.seikyuYmd <= this.lastShimeYmd) {
          this.setInvalidSummaryMessage('BZME0001')
          return false
        }
      }
      this.loadFromCache()
        .then((c) => {
          if (!this.isSeikyu) {
            // 未請求（受注情報）の場合
            var msgInfo = {}
            if (c.value.conditions.shimebiIgaiHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('BILE0007')))
              msgInfo.message = message.get('BILE0007', ['締日以外の未請求も表示する'])
              this.setSummaryMessage(msgInfo)
              return false
            }
            if (c.value.conditions.seikyuDomeHyojiFlg) {
              // 再検索を促すメッセージを表示
              msgInfo = JSON.parse(JSON.stringify(message.getInfo('BILE0007')))
              msgInfo.message = message.get('BILE0007', ['請求止も表示する'])
              this.setSummaryMessage(msgInfo)
              return false
            }
          }
          this.Effects.loadStart()
          this.dispSeikyusho = `請求書_${this.getTimeStamp()}.pdf`
          // 請求番号は画面再検索時のキーとなりうる項目のため、帳票出力（請求作成）後に対象となった請求番号を取得する必要がある
          var conditions = JSON.parse(JSON.stringify(c.value.conditions))
          var pathPrint = ''
          var pathNoPrint = ''
          if (seikyushoKarihakkoFlg) {
            // 請求書仮発行の場合
            conditions.seikyushoKarihakkoFlg = true
            pathPrint = '/api/v1/d2bild0010/printbillkari'
            pathNoPrint = '/api/v1/d2bild0010/createseikyudatakari'
          } else {
            // 請求書発行の場合
            pathPrint = '/api/v1/d2bild0010/printbill'
            pathNoPrint = '/api/v1/d2bild0010/createseikyudata'
          }

          if (this.isNotExistSeikyushoLayoutKbn) {
            // 請求レイアウト区分が設定されていない場合
            return this.HttpClient
              // 発行処理前の請求No一覧を取得
              .post('/api/v1/d2bild0020/searchseikyunofromseikyu', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                this.HttpClient
                  // 非帳票出力処理（請求作成のみ）
                  .post(pathNoPrint, c.value.conditions)
                  .then(data => {
                    // 発行処理後の請求No一覧を取得（発行処理対象の請求Noを抽出）
                    this.searchSeikyuNoAfter(c, conditions, seikyushoKarihakkoFlg, beforeResult)
                  })
              })
          } else {
            return this.HttpClient
              // 発行処理前の請求No一覧を取得
              .post('/api/v1/d2bild0020/searchseikyunofromseikyu', conditions)
              .then((before) => {
                var beforeResult = before.payload || []
                this.HttpClient
                  // 帳票出力処理
                  .requestFileByPost(pathPrint, c.value.conditions)
                  .then(data => {
                    console.log('★', data)
                    // aタグにファイル仕込んでClickする処理
                    const blob = new Blob([data], { type: 'application/pdf' })
                    console.log('★2', blob)
                    const elem = document.getElementById('seikyushoDownload')
                    elem.href = window.URL.createObjectURL(blob)
                    elem.click()
                    // 発行処理後の請求No一覧を取得（発行処理対象の請求Noを抽出）
                    this.searchSeikyuNoAfter(c, conditions, seikyushoKarihakkoFlg, beforeResult)
                  })
              })
          }
        })
    },
    searchSeikyuNoAfter: function (c, conditions, seikyushoKarihakkoFlg, beforeResult) {
      this.HttpClient
        .post('/api/v1/d2bild0020/searchseikyunofromseikyu', conditions)
        .then((after) => {
          var afterResult = after.payload || []
          var result = afterResult.filter((elem) => {
            return beforeResult.indexOf(elem) === -1
          })
          if (result.length > 0) {
            // 請求情報が作成された場合
            // paramsの値を処理後の情報に更新
            this.params.seikyusho = '出力済'
            // 請求番号を取得
            this.params.seikyuNo = result[0]
            if (seikyushoKarihakkoFlg) {
              // 請求書仮発行の場合
              this.params.kariHakkoFlg = true
            }
            // 画面再検索のために再キャッシュ
            const cache = {
              rows: c.value.rows,
              conditions: c.value.conditions,
              searchText: c.value.searchText,
              params: this.params
            }
            this.saveToChache(cache)
              .then(() => {
              })
            // 画面再表示
            this.initialize()
            // 完了処理
            // this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          } else {
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          }
        })
    },
    onPrintAgainButtonClick: function () {
      this.Effects.loadStart()
      this.dispSeikyusho = `請求書_${this.getTimeStamp()}.pdf`
      var path = '/api/v1/d2bild0010/printbillagain'
      if (this.isNotExistSeikyushoLayoutKbn) {
        // 請求レイアウト区分が設定されていない場合
        // 完了処理
        this.Effects.loadComplete()
        this.setInvalidSummaryMessage('COMI0005')
      } else {
        return this.HttpClient
          .requestFileByPost(path, this.conditions)
          .then(data => {
            // aタグにファイル仕込んでClickする処理
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('seikyushoDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            // // 画面再表示
            // this.initialize()
            // 完了処理
            this.Effects.loadComplete()
            this.setInvalidSummaryMessage('COMI0005')
          })
      }
    },
    searchValidate: function () {
      return true
    },
    onHideFilterButtonClick: function (e) {
      const rowFilter = {
        seikyuKingaku: this.hideFlg ? 1 : 0
      }
      this.rowFilterConditions = Object.assign({}, rowFilter)
    },
    hideFilter (elem) {
      const self = this
      return (!self.rowFilterConditions.seikyuKingaku ||
              elem.unchinGokeiZeikomi >= self.rowFilterConditions.seikyuKingaku ||
              elem.kihonUnchin >= self.rowFilterConditions.seikyuKingaku ||
              elem.jikanWarimashiKingaku >= self.rowFilterConditions.seikyuKingaku ||
              elem.kyoriWarimashiKingaku >= self.rowFilterConditions.seikyuKingaku ||
              elem.keisuWarimashiKingaku >= self.rowFilterConditions.seikyuKingaku ||
              elem.nenryoWarimashiKingaku >= self.rowFilterConditions.seikyuKingaku ||
              elem.userKazeiKingakuGokei >= self.rowFilterConditions.seikyuKingaku ||
              elem.tax >= self.rowFilterConditions.seikyuKingaku ||
              elem.hiwayPrice >= self.rowFilterConditions.seikyuKingaku ||
              elem.userUchizeiKingakuGokei >= self.rowFilterConditions.seikyuKingaku ||
              elem.userHikazeiKingakuGokei >= self.rowFilterConditions.seikyuKingaku)
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    },
    getShimeJisseki: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get('/api/v1/TrKessanGetsujiKanri/GetAll')
          .then((data) => {
            if (data.payload) {
              var seikyuShimeList = data.payload.map((elem) => {
                elem.taishoShimeYmd = new Date(elem.taishoYm + '/' + elem.taishoShimeDay)
                return elem
              }).filter(function (elem) {
                return elem.taishoGyomuCd === '01' && elem.delFlg === false
              })
              this.lastShimeYmd = seikyuShimeList.length !== 0 ? filter.dateFormatter(seikyuShimeList[seikyuShimeList.length - 1].taishoShimeYmd) : ''
            }
            resolve()
          })
      })
    }
  }
}
